import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { AnimationModule } from "../../animation/animation.module";
import { AvatarModule } from "../../avatar/avatar.module";
import { MaterialModule } from "../../../../../modules/material/material.module";
import { PipesModule } from "../../../pipes/pipes.module";
import { TranslateModule } from "@ngx-translate/core";
import { SaysoPreviewModule } from "../sayso-preview.module";

import { AppTopicsListPreviewComponent } from "./app-topics-list-preview.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AnimationModule,
    AvatarModule,
    MaterialModule,
    PipesModule,
    TranslateModule,
    SaysoPreviewModule
  ],
  declarations: [AppTopicsListPreviewComponent],
  exports: [AppTopicsListPreviewComponent]
})
export class AppSaysoPreviewModule {}
